import MapboxClient from "mapbox/lib/services/geocoding";
import Address from "@/models/address";

const client = new MapboxClient("pk.eyJ1IjoiY2FtZXJvbnByZWJibGUiLCJhIjoiWGhROVZ2VSJ9.qH4CfsA9rJ-4IrofeaSLMw");

function featureScore(feature) {
  return Math.round(feature.relevance * 100) / 100.0;
}

function filterRelevantAddresses(features) {
  const maxScore = Math.max(...features.map(feature => featureScore(feature)));
  return features.filter(feature => featureScore(feature) === maxScore);
}

function buildAddresses(features) {
  return features.map(feature => Address.fromGeoJSON(feature));
}

function didYouMean(query) {
  return client.geocodeForward(query, { country: "NZ", limit: 10, place_type: "address" })
    .then(response => response.entity.features)
    .then(filterRelevantAddresses)
    .then(buildAddresses);
}

function autoSuggest(query) {
  return client.geocodeForward(query, { country: "NZ", limit: 10, place_type: "address,locality,neighborhood" })
    .then(response => response.entity.features)
    .then(filterRelevantAddresses)
    .then(buildAddresses);
}

export { didYouMean, autoSuggest };



// WEBPACK FOOTER //
// ./src/services/mapbox.js